<template>
  <div class="upload-wrapper">
    <el-upload
      action=""
      :file-list="fileList"
      :limit="limit"
      :before-upload="beforeUpload"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      list-type="picture-card"
      :disabled="disabled"
      :class="disabled || fileList.length >= limit ? 'is-hide' : ''"
    >
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }" class="slot-card">
        <img
          v-if="fileTypeValue == 'image'"
          :src="file.url"
          style="width: 100%"
          class="upload-image"
        />
        <video
          v-else-if="fileTypeValue == 'video'"
          :src="file.url"
          style="width: 100%"
          class="upload-image"
        />
        <div
          v-else-if="fileTypeValue == 'audio'"
          style="display: flex;align-items: center;height: 100%;text-align: center;margin: 0 auto;width: 80%;"
        >
          音频文件 :{{ file.name }}
        </div>
        <!-- <audio
          v-else-if="fileTypeValue == 'audio'"
          :src="file.url"
          style="width: 100%"
          class="upload-image"
        /> -->
        <div class="upload-handle" @click.stop>
          <div class="handle-icon" @click="imagePreview(file.url)">
            <i class="el-icon-zoom-in" />
            <span>预览</span>
          </div>
          <div
            class="handle-icon"
            @click="deleteImg(file.uid)"
            v-if="!disabled"
          >
            <i class="el-icon-delete" />
            <span>删除</span>
          </div>
        </div>
      </div>
    </el-upload>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="previewVisible" width="60%" append-to-body>
      <img
        v-if="fileTypeValue == 'image'"
        :src="previewUrl"
        style="width: 100%"
      />
      <video
        v-else-if="fileTypeValue == 'video'"
        :src="previewUrl"
        controls
        style="width: 100%"
      />
      <audio
        v-else-if="fileTypeValue == 'audio'"
        :src="previewUrl"
        controls
        style="width: 100%"
      />
    </el-dialog>
  </div>
</template>

<script>
import { uploadFile } from "@/utils/alioss.js";
export default {
  name: "UploadResource",

  props: {
    /** v-model */
    value: {
      type: [String, Array],
      default: ""
    },

    /** 最大文件大小（MB） */
    maxSize: {
      type: Number,
      default: 50
    },

    /** 文件数量限制 */
    limit: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * 文件类型
     * image | video | custom
     */
    fileTypes: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      fileList: [],
      previewVisible: false,
      previewUrl: ""
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.fileList = [];
          return;
        }

        const list = Array.isArray(val) ? val : [val];
        this.fileList = list.map(url => ({
          name: url.split("/").pop(),
          url
        }));
      }
    }
  },
  computed: {
    fileTypeValue() {
      const filesTypes = {
        image: ["jpg", "jpeg", "png", "gif", "bmp", "webp"],
        video: ["mp4", "ogg", "webm", "mkv"],
        audio: ["mp3", "wav", "ogg", "webm", "mkv"]
      };
      let flag = "";
      if (this.fileList.length > 0) {
        Object.entries(filesTypes).forEach(item => {
          if (
            item[1].includes(
              this.fileList[0].name
                .split(".")
                .slice(-1)[0]
                .toLowerCase()
            )
          ) {
            flag = item[0];
          }
        });
      }

      return flag;
    }
  },
  methods: {
    imagePreview(url) {
      this.previewUrl = url;
      this.previewVisible = true;
    },
    /** 上传前校验 */
    beforeUpload(file) {
      // 大小限制
      const isValidSize = file.size / 1024 / 1024 < this.maxSize;
      if (!isValidSize) {
        this.$message.error(`文件不能超过 ${this.maxSize}MB`);
        return false;
      } // 类型限制

      if (file.name) {
        if (
          !this.fileTypes.includes(
            file.name
              .split(".")
              .slice(-1)[0]
              .toLowerCase()
          )
        ) {
          this.$message.error(`仅支持 ${this.fileTypes.join("、")} 格式文件`);
          return false;
        }
      }

      this.upload(file);
      return false;
    },
    deleteImg(uid) {
      this.fileList = this.fileList.filter(item => item.uid !== uid);
      this.$emit("input", this.fileList);
    },
    /** 类型校验 */
    checkFileType(file) {
      // 如果传了 fileTypes，优先用后缀校验
      if (this.fileTypes && this.fileTypes.length) {
        const suffix = file.name
          .split(".")
          .pop()
          .toLowerCase();
        return this.fileTypes.map(e => e.toLowerCase()).includes(suffix);
      }

      // // 否则走 image / video 默认规则
      // if (this.type === "image") {
      //   return file.type.startsWith("image/");
      // }

      // if (this.type === "video") {
      //   return file.type.startsWith("video/");
      // }

      return true;
    },
    /** OSS 上传 */
    async upload(file) {
      const loading = this.$loading({
        lock: true,
        text: "文件上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      console.log(loading);
      try {
        const res = await uploadFile(file.type.split("/")[0], file, file.name);

        if (res.res.status === 200) {
          const url = res.res.requestUrls[0];
          const fileItem = {
            name: file.name,
            url
          };

          this.fileList.push(fileItem);

          const result = this.limit === 1 ? url : this.fileList.map(f => f.url);
          // v-model
          this.$emit("input", result);

          // 成功回调
          this.$emit("success", {
            fileName: file.name,
            url,
            list: this.fileList
          });
        }
      } catch (err) {
        this.$message.error("上传失败");
      } finally {
        loading.close();
      }
    },

    /** 删除文件 */
    handleRemove(file, fileList) {
      this.fileList = fileList;

      const result = this.limit === 1 ? "" : fileList.map(f => f.url);
      this.$emit("input", result);
    },

    /** 超出数量 */
    handleExceed() {
      this.$message.warning(`最多只能上传 ${this.limit} 个文件`);
    }
  }
};
</script>

<style scoped lang="less">
.upload-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.upload-handle {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 10;
  cursor: pointer;
  transition: 0.5s;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.4);
  /* transition: var(--el-transition-duration-fast); */
  align-items: center;
  justify-content: center;
}
.upload-handle:hover {
  opacity: 1;
}
.handle-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 6%;
  color: aliceblue;
}
.handle-icon .el-icon {
  margin-bottom: 40%;
  font-size: 130%;
  line-height: 130%;
}

.handle-icon span {
  font-size: 85%;
  line-height: 85%;
}
.upload-wrapper {
  /deep/ .slot-card {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .is-hide {
    /deep/ .el-upload {
      display: none !important;
    }
    /deep/ .slot-card {
      cursor: not-allowed;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UploadFile.vue